import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import dayjs from 'dayjs';



//mui
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

//icons 
import CalendarToday from '@material-ui/icons/CalendarToday';
import LocationOn from '@material-ui/icons/LocationOn';
import LinkIcon from '@material-ui/icons/Link';
import MuiLink from '@material-ui/core/Link';

const Link = require('react-router-dom').Link;

const styles = (theme) => ({
    ...theme.spread
});

class StaticProfile extends Component {

    render() {
        const { classes, profile: { handle, createdAt, imgUrl, bio, website, location } } = this.props;
        return (
            <Paper className={classes.paper}>
                <div className={classes.profile}>
                    <div className='image-wrapper'>
                        <img src={imgUrl} alt='profile' className='profile-image' />

                    </div>
                    <hr />
                    <div className='profile-details'>
                        <MuiLink component={Link} to={`/users/${handle}`} color='primary' variant='h5' >
                            @{handle}

                        </MuiLink>
                        <hr />
                        {bio && <Typography variant='body2'>{bio}</Typography>}
                        <hr />
                        {location && (
                            <React.Fragment>
                                <LocationOn color='primary' /> <span>{location}</span> <hr />
                            </React.Fragment>)}
                        {website && (
                            <React.Fragment>
                                <LinkIcon color='primary' />
                                <a href={website} target='_blank' rel='noopener noreferrer'>
                                    {' '}{website}
                                </a>
                                <hr />
                            </React.Fragment>
                        )}
                        <CalendarToday color='primary' />{' '}
                        <span>Joined {dayjs(createdAt).format('MMM YYYY')}</span>
                    </div>
                </div>
            </Paper>
        )
    }
}

StaticProfile.propTypes = {
    profile: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(StaticProfile);
